import { useAppSelector } from '@App/hooks'

import { Trade } from '@Redux/slices/trade/trades/types'

import { EditTrade } from '../../../SpotOrderTrade/components/LimitOrderBlock/components/EditTrade'
import { CancelTradeProvider } from '../../../SpotOrderTrade/components/LimitOrderBlock/components/EditTrade/components/AmountToClose/model'
import { ORDER_ACTION_TYPE } from '../../../SpotOrderTrade/components/types'
import { ORDER_TYPE_NAME } from '../../../SpotOrderTrade/containers/types'

import s from './styles.module.scss'

export const EditTradeContainer = ({ order }: { order: Trade | null }) => {
  const market = useAppSelector((state) => state.config.markets.find((m) => m.id === order?.market.id))

  return (
    order &&
    market ? (
      <div className={s.container}>
        <CancelTradeProvider order={order} key={order.id}>
          <EditTrade
            order={order}
            operationType={order.action_type as ORDER_ACTION_TYPE}
            current_market={market}
            orderType={ORDER_TYPE_NAME.LIMIT}
          />
        </CancelTradeProvider>
      </div>
    ) : <></>
  )
}
